<script setup>
import useSharedData from "@/use/SharedData";
import axios from "axios";
import {defineEmits, defineProps, ref, watch} from "vue";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";

const props = defineProps({
    value: [Number, Array],
    readonly: Boolean,
    disabled: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
    periodType: String,
});

const emit = defineEmits(["input", "change"]);

const {$i18n} = useTools();
const {formatedDate} = useSharedMethod();
const {loading, inputColor, inputBackgroundColor} = useSharedData();

const item = ref(null);
const items = ref([]);

function getYearPeriods() {
    loading.value = true;
    items.value = [];
    axios.get("/reports/getYearPeriods", {
        params: {
            periodType: props.periodType,
        }
    }).then((response) => {
        let currentDateRange = response.data.currentDateRange;
        let year = response.data.year;
        response.data.yearPeriods.forEach((item, index) => {
            items.value.push(
                {
                    id: index,
                    name: getName(item, index, year)
                }
            );
            if (item.start === currentDateRange.start && item.end === currentDateRange.end && (props.value === null || props.value === undefined)) {
                selectCurrentRank(index)
            }
        });
        
        
    }).finally(() => {
        loading.value = false;
    })
}

function selectCurrentRank(rank) {
    item.value = rank;
    // input(rank);
}

function getName(item, index, year) {
    switch (props.periodType) {
        case 'WEEK':
            return `${$i18n.t(`period_type.${props.periodType}`)} ${index + 1} [${formatedDate(item.start)} - ${formatedDate(item.end)}]`;
        case 'MONTH':
            return `${$i18n.t(`period_type.month_${index + 1}`)} ${year}`;
        case 'SEMESTER':
            return `${$i18n.t(`period_type.${props.periodType}`)} ${index + 1} [${formatedDate(item.start)} - ${formatedDate(item.end)}]`;
        case 'YEAR':
            return `${$i18n.t(`period_type.${props.periodType}`)} ${year}`;
        
    }
}

function input(value) {
    emit('input', value)
}

function change() {
    emit('change')
}

watch(() => props.value, () => {
    item.value = props.value;
}, {immediate: true});

watch(() => props.periodType, () => {
    if (props.periodType) {
        getYearPeriods();
    } else {
        items.value = [];
    }
}, {immediate: true});

</script>

<template>
    <div>
        <v-autocomplete
            v-model="item"
            :items="items"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="inputBackgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            @change="change"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>
        
        <input type="hidden">
    </div>
</template>

<style scoped>

</style>